import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/index.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from './pages/home';
import AboutUs from './pages/about-us';
import Parcours from './pages/parcours';
import Home2 from './pages/home-2';
import Acceuil from './pages/accueil';
import CommentCaMarche from 'pages/commentCamarche';
import Freelances from 'pages/freelances';
import Contact from 'pages/contact';

import Inscription from 'pages/inscription';
import Connexion from 'pages/connexion';
import Services from 'pages/services';
import MessageReport from 'pages/message-report';

import ScrollToTop from 'components/slideToTop/slideTop';
import SingleFreelanceProfile from 'pages/freelance/singleFreelanceProfile';
import SubCategory from 'pages/subCategory';
import LostPass from 'pages/lostpass';
import Profile from 'pages/profile';
import ProfilWorker from 'pages/profil-worker';
import CGU from 'pages/cgu';
import ML from 'pages/ml';
import PDD from 'pages/pdd';
import FourOfour from 'pages/404';
import ResetPassword from 'pages/reset-password';
import ResetSucceded from 'pages/reset-succeded';
import SetAvailability from 'pages/confirmation-disponibilité';


function App() {
    return (
        <Router>
            <ScrollToTop />
            <div className=''>
                <Routes>
                    <Route path="/" element={<Acceuil />} />
                    
                    <Route path="/inscription" element={<Inscription />} />
                    <Route path="/inscription-entreprises" element={<Home2 />} />
                    <Route path="/inscription-freelances" element={<Home2 type='freelance' />} />
                    <Route path="/externalisation-appels-assistants-virtuels" element={<Home2 isTeleOp={true} />} />

                    <Route path="/parcours-entreprise" element={<Parcours />} />
                    <Route path="/parcours-freelance" element={<Parcours type='freelance' />} />

                    <Route path="/a-propos" element={<AboutUs />} />
                    <Route path="/plateforme-freelance" element={<Freelances />} />
                    <Route path="/contactez-nous" element={<Contact />} />
                    <Route path="/prestations-entreprises" element={<Services />} />

                    <Route path="/comment-ca-marche-entreprises" element={<CommentCaMarche isFreelance={false} />} />
                    <Route path="/comment-ca-marche-freelances" element={<CommentCaMarche isFreelance={true} />} />
                    
                    <Route path="/connexion" element={<Connexion />} />
                    <Route path='/mot-de-passe-perdu' element={<LostPass />} />
                    <Route path="/nouveau-mot-de-passe" element={<MessageReport hasErrors={false} lostMail={true}/>} />
                    <Route path="/adresse-invalide" element={<MessageReport hasErrors={true} lostMail={true}/>} />
                    <Route path="/merci" element={<MessageReport hasErrors={false} />} />
                    <Route path="/erreur" element={<MessageReport hasErrors={true} />} />

                    <Route path="/confirmation-de-disponibilite" element={<SetAvailability />} />

                    <Route path='/profil-worker' element={<ProfilWorker />} />
                    <Route path='/reinitialise-password' element={<ResetPassword />} />
                    <Route path='/reinitialisation-reussi' element={<ResetSucceded  />} />
                    <Route path="/user/:index" element={<SingleFreelanceProfile />} />
                    <Route path="/plateforme-freelance/:query" element={<SubCategory />} />
                    <Route path='/profil' element={<Profile />} />

                    <Route path='/conditions-generales-d-utilisation' element={<CGU/>} />
                    <Route path='/mentions-legales' element={<ML/>} />
                    <Route path='/protection-des-donnees' element={<PDD/>} />

                    <Route path='*' element={<FourOfour/>}/>
                </Routes>
            </div>
        </Router>
    );
}

export default App;
